export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20orange%20and%20dark%20gradient%20abstract%20background%20with%20flowing%20curved%20lines%20reminiscent%20of%20film%20strips%2C%20subtle%20geometric%20play%20button%20shapes%2C%20soft%20cinematic%20glow%20particles%2C%20modern%20streaming%20platform%20aesthetic%2C%20rich%20amber%20to%20deep%20charcoal%20gradient%2C%20artistic%20video%20platform%20atmosphere%2C%20high%20detail%20editorial%20quality&width=1600&height=900&seq=juzi-hero-bg&orientation=landscape"
          alt="桔子视频平台主视觉背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-primary-200">每日更新 · 全网同步</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-background-50 leading-tight">
              桔子视频 · 西瓜视频丝瓜视频
              <br className="hidden sm:block" />
              高清全集免费看
            </h1>

            <p className="mt-2 text-lg md:text-xl text-primary-300 font-medium">
              不缓冲 · 不卡顿 · 畅享丝滑观影体验
            </p>

            <div className="mt-6 text-sm md:text-base text-background-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0 space-y-3">
              <p>
                桔子视频聚合西瓜视频、丝瓜视频等主流平台海量资源，涵盖热播电视剧、院线大片、综艺动漫与纪录片。
                每日自动同步最新剧集，无需反复搜索，打开即看，所有内容完全免费。
              </p>
              <p>
                本站采用智能分发加速技术，确保高清画质流畅播放不缓冲。无论是追最新热剧还是重温经典老片，
                桔子视频都能为您提供一站式的便捷观影入口。
              </p>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-5 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-500/30 flex items-center justify-center">
                  <i className="ri-video-line text-primary-300 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50">2.8万+</div>
                  <div className="text-xs text-background-200/60">视频资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-500/30 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-300 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50">极速加载</div>
                  <div className="text-xs text-background-200/60">全网加速</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-secondary-500/20 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-300 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50">7×24h</div>
                  <div className="text-xs text-background-200/60">持续同步</div>
                </div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <button
                onClick={() => handleScroll('#index')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <i className="ri-compass-3-line mr-2"></i>
                探索精彩内容
              </button>
              <button
                onClick={() => handleScroll('#about')}
                className="w-full sm:w-auto px-8 py-3 border border-background-300/40 text-background-100 font-medium rounded-full hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <i className="ri-information-line mr-2"></i>
                了解桔子视频
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg mx-auto">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/20 rounded-3xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-background-300/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20video%20streaming%20interface%20mockup%20with%20warm%20orange%20theme%2C%20modern%20dark%20UI%20displaying%20movie%20posters%20in%20a%20grid%20layout%2C%20soft%20ambient%20glow%2C%20abstract%20play%20button%20accents%2C%20minimal%20design%2C%20professional%20OTT%20platform%20screenshot%20style%2C%20warm%20golden%20highlights%20on%20dark%20background&width=800&height=600&seq=juzi-hero-visual&orientation=landscape"
                  alt="桔子视频观影界面预览"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-16 h-16 md:w-20 md:h-20 bg-accent-500 rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-play-fill text-background-50 text-2xl md:text-3xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}